export default "__VITE_ASSET__ab7ddc30__"